module.exports = __webpack_public_path__ + "cd09b30348d817c0c99acc7b2b95609b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/24_prop_19.png
// module id = 125
// module chunks = 0